import { useEffect, useRef, useState } from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'

import { ToggleColorScheme } from './ToggleColorScheme'
import { SwitchLanguage } from './SwitchLanguage'
import { DebugOptions } from './DebugOptions'

import type { DebugAction } from './types'

type AppDebugBarProps = {
    actions?: DebugAction[]
}

export const AppDebugBar = ({ actions }: AppDebugBarProps) => {
    const ref = useRef<HTMLDivElement | null>(null)

    const [open, setOpen] = useState(false)

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false)
            }
        }
        document.addEventListener('click', handleClickOutside, true)
        return () => {
            document.removeEventListener('click', handleClickOutside, true)
        }
    }, [])

    return (
        <div
            ref={ref}
            className="fixed right-0 top-0 mr-0 mt-1 rounded-l-sm bg-red-500 shadow-lg"
            style={{ zIndex: 999999 }}
        >
            <div className="relative flex items-center">
                {open && (
                    <>
                        <ToggleColorScheme />
                        <SwitchLanguage />
                        <DebugOptions actions={actions} />
                    </>
                )}
                <div className="py-2 text-white hover:bg-white/10 active:bg-black/20" onClick={() => setOpen(!open)}>
                    {open ? <ChevronRightIcon className="h-5 w-3" /> : <ChevronLeftIcon className="h-5 w-3" />}
                </div>
            </div>
        </div>
    )
}
